import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountEntityRaw } from "../interface";
import { iamAccountEntityRaw } from "../schema";

export class IAMAccountEntity {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountEntity.configValidationSchema()
  );

  constructor(readonly value: IAMAccountEntityRaw) {
    JsonSchemaValidator.assert(IAMAccountEntity.validation, value);
  }

  toJSON(): IAMAccountEntityRaw {
    return this.value;
  }

  private static configValidationSchema() {
    return iamAccountEntityRaw;
  }
}
